import { LncBaseApiClientService } from '@odw/lnc-services/js-services/api-client/lnc-base-api-client.service';

/**
 * Service pour réaliser les appels à l'api de mes-autorisations-colloc
 */
export default class MesAutorisationsCollocService extends LncBaseApiClientService {
  /**
   * Retourne la liste des compétences actives
   * @param {string} siren Le siren pour lequel nous voulons récupérer les compétences actives
   * @returns {Promise<CompetenceSirenDto>} La promesse d'une réponse.
   */
  getCompetencesActivesSiren(siren, type = null, niveau = null) {
    const query = type != null && niveau != null ? `?type=${type}&niveau=${niveau}` : '';
    return new Promise((resolve, reject) => {
      this.get('/api/private/v1/collectivites/' + siren + '/competences' + query)
        .then((response) => {
          resolve(response.content);
        })
        .catch(() => {
          reject();
        });
    });
  }

  /**
   * Vérification des habilitations de l'utilisateur et du siren requêté, puis récupération du codeInsee
   * et du code TOTP correspondant aux type et niveau spécifiés
   * @param {*} cnAlex
   * @param {*} siren
   * @param {*} type
   * @param {*} niveau
   * @param {*} date
   * @returns {Promise<MapHashDto>}
   */
  getMapHash(cnAlex, siren, type, niveau, date) {
    return new Promise((resolve, reject) => {
      this.get(
        '/api/private/v1/personnes/' +
          cnAlex +
          '/collectivites/' +
          siren +
          '/types/' +
          type +
          '/niveaux/' +
          niveau +
          '/date/' +
          date +
          '/map-hash',
      )
        .then((response) => {
          resolve(response.content);
        })
        .catch(() => {
          reject();
        });
    });
  }
}
